import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No assets. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Loading assets data. Please wait. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    title: "Currency Report",
    subtitle: "Get the sum of all assets into Satstreet customers."
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            class: "table-striped p-datatable-sm",
            value: _ctx.getFilteredItems,
            rows: 10,
            rowsPerPageOptions: [10, 20, 50],
            autoLayout: true,
            loading: _ctx.isLoading,
            paginator: true,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control w-50",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                }, null, 512), [
                  [_vModelText, _ctx.mainSearch]
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_4
            ]),
            loading: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Asset" }, {
                body: _withCtx((slotProps) => [
                  _createVNode("b", null, _toDisplayString(slotProps.data.currency.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Amount",
                class: "text-right"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, _toDisplayString(slotProps.data.currency.currencyType === 1
                    ? '$' + _ctx.formatPrice(slotProps.data.amount)
                    : _ctx.formatZeros(
                        slotProps.data.amount,
                        slotProps.data.currency.exact
                      )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "CAD Price",
                class: "text-right"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, " $ " + _toDisplayString(_ctx.formatPrice(
                    _ctx.parseCadValue(slotProps.data.currency.coingeckoId)
                  )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "CAD Value",
                class: "text-right"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, " $ " + _toDisplayString(_ctx.formatPrice(
                    _ctx.parseCadValue(slotProps.data.currency.coingeckoId) *
                      slotProps.data.amount
                  )), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ])
      ])
    ]),
    _: 1
  }))
}